export default __webpack_public_path__ + "static/media/step5.23af8979.png";